export const TOKEN: string = 'bearer-token';
export const REFRESH_TOKEN: string = 'refresh-token';
export const SPYEE_TOKEN: string = 'spyee-token';
export const SPYEE_REFRESH_TOKEN: string = 'spyee-refresh-token';
export const USER: string = 'user';
export const ORGANIZATION: string = 'organization';
export const EVENT_STORAGE: string = 'storage';
export const EVENT_AUTH_LOGIN: string = 'auth-login';
export const EVENT_AUTH_LOGOUT: string = 'auth-logout';
export const EVENT_AUTH_SET_PASSWORD: string = 'auth-set-password';
